/**
 * Created by rathompson on 12/30/21
 * File: LoadingButton
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useEffect, useMemo, useState } from 'react'
import { addMinutes, differenceInSeconds, format, addSeconds } from 'date-fns'
import { Button, Body } from '@panwds/react-ui'
import { ClockIcon } from '@panwds/icons'
import { BUTTON_ERROR, LABEL_TAKING_LONGER_THAN_USUAL } from '../../subscription/constants/LabelConstants'

const MAX_PROGRESS = 100
const TICK = 100
const TIMER_DURATION_MINUTES = 30

const LoadingButton = ({ children, progress, error, addClassName, ...btnProps }) => {

  const [now, setNow] = useState(new Date())
  const [end] = useState(addMinutes(new Date(), TIMER_DURATION_MINUTES))

  useEffect(() => {
    const intervalID = setInterval(() => {
      setNow(new Date())
      if (progress >= MAX_PROGRESS) {
        clearInterval(intervalID)
      }
    }, TICK)
    if (error) {
      clearInterval(intervalID)
    }
  }, [error, progress])

  const appearance = useMemo(() => {
    if (error) {
      return 'secondary-destructive'
    }
    return progress < MAX_PROGRESS ? 'primary' : 'secondary'
  }, [error, progress])

  const remaining = useMemo(() => differenceInSeconds(end, now), [end, now])

  const timeMessage = useMemo(() => {
    if (remaining < 0) {
      return LABEL_TAKING_LONGER_THAN_USUAL
    }
    return format(addSeconds(new Date(0), remaining), 'mm:ss')
  }, [remaining])

  return (
    <div className={`tw-flex tw-items-center tw-gap-2 ${addClassName}`.trim()}>
      {!error && progress < MAX_PROGRESS && (
        <>
          <ClockIcon size='sm' />
          <Body>{timeMessage}</Body>
        </>
      )}
      <Button {...{ appearance, ...btnProps }} disabled={error || progress < MAX_PROGRESS}>
        {progress < MAX_PROGRESS && <div className="tw-bg-blue-600 tw-absolute tw-left-0 tw-h-full tw-rounded" style={{ right: error ? MAX_PROGRESS : `${MAX_PROGRESS - progress}%` }}/>}
        <div style={{ zIndex: 9999 }}>{error ? BUTTON_ERROR : children}</div>
      </Button>
    </div>
  )
}

export default LoadingButton
